<template>
  <div class="animated fadeIn">
    <b-row class="mb-4">
      <b-col lg="10">
        <b-form-radio-group
          class="mr-3"
          id="radiosBtn"
          buttons
          button-variant="outline-primary"
          v-model="vwReport"
          name="radiosBtn"
          @change.native="loadReport"
        >
          <b-form-radio class="mx-0 reportRadios" value="WeeklyTracker"
            >Weekly Order Tracker</b-form-radio
          >
          <!-- <b-form-radio class="mx-0 reportRadios" value="Stats"
            >Seminar/Appt Stats</b-form-radio
          > -->
          <b-form-radio class="mx-0 reportRadios" value="PPT"
            >P.P.T.</b-form-radio
          >
          <b-form-radio class="mx-0 reportRadios" value="Comparison"
            >RSVP Comparison</b-form-radio
          >
          <b-form-radio class="mx-0 reportRadios" value="Analysis"
            >Analysis by Producer</b-form-radio
          >
          <!--
          <b-form-radio class="mx-0 reportRadios" value="Aggregates"
            >Aggregates</b-form-radio
          >-->
        </b-form-radio-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="3" v-if="reportHasDateFilters">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>From</b-input-group-text>
            </b-input-group-prepend>
            <datepicker
              @dp-change="changeFromDate"
              :value="globals.default_dates.from_date"
              :config="options"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3" v-if="reportHasYYMMFilters">
        <b-form-group>
          <CoolSelect
            v-model="globals.ppt_year"
            class="form-input dropdown-content"
            placeholder="Year"
            theme="bootstrap"
            tooltip="Year"
            :items="territory.ppt_years"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text>Year</b-input-group-text>
              </b-input-group-prepend>
            </template>
          </CoolSelect>
        </b-form-group>
      </b-col>
      <b-col md="3" v-if="reportHasYYMMFilters">
        <b-form-group>
          <CoolSelect
            v-model="globals.ppt_month"
            class="form-input dropdown-content"
            placeholder="Month"
            theme="bootstrap"
            tooltip="Month"
            :items="territory.ppt_months"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text>Month</b-input-group-text>
              </b-input-group-prepend>
            </template>
          </CoolSelect>
        </b-form-group>
      </b-col>
      <b-col md="3" v-if="reportHasDateFilters">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>To</b-input-group-text>
            </b-input-group-prepend>
            <datepicker
              @dp-change="changeToDate"
              :value="globals.default_dates.to_date"
              :config="options"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-form-group>
          <CoolSelect
            v-if="reportHasPPFilters"
            v-model="globals.default_pp"
            class="form-input dropdown-content"
            placeholder="Program Planner"
            theme="bootstrap"
            tooltip="Program Planner"
            :items="reportUsers"
            item-text="UserName"
            item-value="UserProfileID"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text class="standardizedWidth"
                  >Program Planner</b-input-group-text
                >
              </b-input-group-prepend>
            </template>
          </CoolSelect>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="6" v-if="reportHasTerritorySearch">
        <b-form-group>
          <CoolSelect
            v-if="reportHasTerritorySearch"
            v-model="reportTerritoryEdit"
            class="form-input dropdown-content"
            placeholder="Territory"
            theme="bootstrap"
            tooltip="Territory"
            :items="reportTerritories"
            item-text="TerritoryName"
            item-value="TerritoryID"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text class="standardizedWidth"
                  >Territory</b-input-group-text
                >
              </b-input-group-prepend>
            </template>
          </CoolSelect>
        </b-form-group>
      </b-col>
      <b-col lg="6" v-if="reportHasVendorSearch">
        <b-form-group>
          <CoolSelect
            v-if="reportHasVendorSearch"
            v-model="reportVendorEdit"
            class="form-input dropdown-content"
            placeholder="Vendor"
            theme="bootstrap"
            tooltip="Vendor"
            :items="reportVendors"
            item-text="Name"
            item-value="VendorID"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text class="standardizedWidth"
                  >Vendor</b-input-group-text
                >
              </b-input-group-prepend>
            </template>
          </CoolSelect>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="reportHasMailerSearch">
      <b-col lg="6">
        <b-form-group>
          <CoolSelect
            v-if="reportHasMailerSearch"
            v-model="reportMailerEdit"
            class="form-input dropdown-content"
            placeholder="Mailer"
            theme="bootstrap"
            tooltip="Mailer"
            :items="reportMailers"
            item-text="MailerTypeName"
            item-value="MailerTypeID"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text class="standardizedWidth"
                  >Mailer</b-input-group-text
                >
              </b-input-group-prepend>
            </template>
          </CoolSelect>
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-form-group>
          <CoolSelect
            v-if="reportHasArtworkSearch"
            v-model="reportArtworkEdit"
            class="form-input dropdown-content"
            placeholder="Artwork"
            theme="bootstrap"
            tooltip="Artwork"
            :items="reportArtworks"
            item-text="ArtworkName"
            item-value="ArtworkID"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text class="standardizedWidth"
                  >Artwork</b-input-group-text
                >
              </b-input-group-prepend>
            </template>
          </CoolSelect>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="divider-row" v-if="reportHasSearch">
      <b-col lg="9">
        <b-form-group>
          <b-input-group>
            <b-form-input
              class="divider-input"
              type="text"
              placeholder="Search"
              @keyup="searchWait"
              v-model.lazy="searchString"
            />

            <b-input-group-append>
              <b-input-group-text class="divider-input">
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col
        v-show="seminar.is_seminars_loading || territory.is_territory_loading"
        sm="3"
        class="localBold mt-1"
        ><i class="fa fa-refresh fa-spin localBold mr-2"></i>Synching</b-col
      >
    </b-row>
    <b-row>
      <b-col lg="12">&nbsp;</b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <weeklyTracker v-if="vwReport === 'WeeklyTracker'" />
        <ppt
          v-if="vwReport === 'PPT'"
          :filter_year="globals.ppt_year"
          :filter_month="globals.ppt_month"
          :filter_pp="globals.default_pp.UserProfileID"
        />
        <appointmentTracker v-if="vwReport === 'Stats'" />
        <producerAnalysis v-if="vwReport === 'Analysis'" />
        <rsvpTracker v-if="vwReport === 'Comparison'" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import rsvpTracker from "@/components/reports/rsvpTracker.vue";
import weeklyTracker from "@/components/reports/weeklyTracker.vue";
import appointmentTracker from "@/components/reports/appointmentTracker.vue";
import producerAnalysis from "@/components/reports/producerAnalysis.vue";
import ppt from "@/components/reports/ppt.vue";
import { mapState, mapGetters } from "vuex";
import { CoolSelect } from "vue-cool-select";
import cTable from "@/views/base/Table.vue";
import { Switch as cSwitch } from "@coreui/vue";
import datepicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
export default {
  name: "dashboard",
  components: {
    rsvpTracker,
    weeklyTracker,
    appointmentTracker,
    producerAnalysis,
    ppt,
    CoolSelect,
    cTable,
    cSwitch,
    datepicker
  },
  data: () => {
    return {
      reportUsers: [],
      reportTerritories: [],
      reportVendors: [],
      reportMalers: [],
      reportArtworks: [],
      reportMonth: "",
      reportYear: new Date().getFullYear().toString(),
      searchString: "",
      vwReport: "WeeklyTracker",
      reportHasDateFilters: true,
      reportHasYYMMFilters: false,
      reportHasPPFilters: true,
      reportHasSearch: true,
      reportHasTerritorySearch: false,
      reportHasVendorSearch: false,
      reportHasMailerSearch: false,
      reportHasArtworkSearch: false,
      reportTerritoryEdit: { TerritoryID: 0, TerritoryName: "All" },
      reportVendorEdit: { VendorID: 0, Name: "All" },
      reportMailerEdit: { MailerTypeID: 0, MailerTypeName: "All" },
      reportArtworkEdit: { ArtworkID: 0, ArtworkName: "All" },
      options: {
        format: "MM/DD/YYYY",
        useCurrent: false
        // ,
        // minDate: new Date()
        // ,
        // daysOfWeekDisabled: [0, 6]
      }
    };
  },

  async created() {
    this.searchString = this.$store.state.globals.default_search_string;

    if (!this.$store.state.globals.default_dates.my_state) {
      this.$store.dispatch("globals/setDefaultDates");
    }
    await this.$store.dispatch("n_user/fetchUsers");

    this.loadReportUsers();

    if (!this.$store.state.territory.territories.length) {
      this.$store
        .dispatch("territory/fetchTerritoryHeaders")
        .then(this.loadReportTerritories());
    } else {
      this.loadReportTerritories();
    }

    if (!this.$store.state.territory.temp_territories.length) {
      this.$store.dispatch("territory/fetchTempTerritoryHeaders");
    }

    if (!this.$store.state.seminar.vendors.length) {
      this.$store
        .dispatch("seminar/fetchVendors")
        .then(this.loadReportVendors());
    } else {
      this.loadReportVendors();
    }

    if (!this.$store.state.seminar.mailer_types.length) {
      this.$store
        .dispatch("seminar/fetchMailerTypes")
        .then(this.loadReportMailers());
    } else {
      this.loadReportMailers();
    }

    if (!this.$store.state.seminar.artwork_types.length) {
      this.$store
        .dispatch("seminar/fetchArtworkTypes")
        .then(this.loadReportArtworks());
    } else {
      this.loadReportArtworks();
    }

    if (!this.$store.state.globals.default_pp) {
      this.$store.dispatch(
        "globals/setDefaultPP",
        this.$store.state.n_user.n_current_user.UserProfileID
      );
    }

    this.reportMonth = this.$store.state.territory.ppt_months[
      new Date().getMonth()
    ];

    this.$store.dispatch("territory/GetPPTYears");

    this.$store.state.globals.ppt_month = this.reportMonth;
    this.$store.state.globals.ppt_year = this.reportYear;
    await this.$store.dispatch("zip/fetchProtectedZips");
  },
  computed: {
    ...mapState(["globals", "territory", "n_user", "seminar"])
  },
  methods: {
    loadReportUsers() {
      this.reportUsers = [];
      this.reportUsers.push({ UserProfileID: 0, UserName: "All" });
      this.$store.state.n_user.n_users.forEach(user => {
        this.reportUsers.push(user);
      });
    },
    loadReportTerritories() {
      this.reportTerritories = [];
      this.reportTerritories.push({ TerritoryID: 0, TerritoryName: "All" });
      this.$store.state.territory.territories.forEach(t => {
        if (t.TerritoryName !== " Select...") {
          this.reportTerritories.push(t);
        }
      });
    },
    loadReportVendors() {
      this.reportVendors = [];
      this.reportVendors.push({ VendorID: 0, Name: "All" });
      this.$store.state.seminar.vendors.forEach(v => {
        this.reportVendors.push(v);
      });
    },
    loadReportMailers() {
      this.reportMailers = [];
      this.reportMailers.push({ MailerTypeID: 0, MailerTypeName: "All" });
      this.$store.state.seminar.mailer_types.forEach(mt => {
        if (mt.MailerTypeName !== " (to be determined)") {
          this.reportMailers.push(mt);
        }
      });
    },
    loadReportArtworks() {
      this.reportArtworks = [];
      this.reportArtworks.push({ ArtworkID: 0, ArtworkName: "All" });
      this.$store.state.seminar.artwork_types.forEach(at => {
        if (at.ArtworkName !== " (to be determined)") {
          this.reportArtworks.push(at);
        }
      });
    },
    loadReport: function() {
      switch (this.vwReport) {
        case "WeeklyTracker":
          this.reportHasDateFilters = true;
          this.reportHasPPFilters = true;
          this.reportHasSearch = true;
          this.reportHasYYMMFilters = false;
          this.reportHasTerritorySearch = false;
          this.reportHasVendorSearch = false;
          this.reportHasMailerSearch = false;
          this.reportHasArtworkSearch = false;
          break;
        case "Stats":
          this.reportHasDateFilters = true;
          this.reportHasPPFilters = true;
          this.reportHasSearch = true;
          this.reportHasYYMMFilters = false;
          this.reportHasTerritorySearch = false;
          this.reportHasVendorSearch = false;
          this.reportHasMailerSearch = false;
          this.reportHasArtworkSearch = false;
          break;
        case "PPT":
          this.reportHasDateFilters = false;
          this.reportHasPPFilters = true;
          this.reportHasSearch = true;
          this.reportHasYYMMFilters = true;
          this.reportHasTerritorySearch = false;
          this.reportHasVendorSearch = false;
          this.reportHasMailerSearch = false;
          this.reportHasArtworkSearch = false;
          break;
        case "Comparison":
          this.reportHasDateFilters = true;
          this.reportHasPPFilters = true;
          this.reportHasSearch = false;
          this.reportHasYYMMFilters = false;
          this.reportHasTerritorySearch = true;
          this.reportHasVendorSearch = true;
          this.reportHasMailerSearch = true;
          this.reportHasArtworkSearch = true;
          break;
        default:
          this.reportHasDateFilters = false;
          this.reportHasPPFilters = false;
          this.reportHasSearch = false;
          this.reportHasYYMMFilters = false;
          this.reportHasTerritorySearch = false;
          this.reportHasVendorSearch = false;
          this.reportHasMailerSearch = false;
          this.reportHasArtworkSearch = false;
      }
    },
    changeFromDate: function(event) {
      this.$store.dispatch("globals/setFromDate", event.target.value);
    },
    changeToDate: function(event) {
      this.$store.dispatch("globals/setToDate", event.target.value);
    },
    searchWait(event) {
      if (this.timer) {
        window.clearTimeout(this.timer);
      }
      this.timer = window.setTimeout(() => {
        this.timer = null;
        this.$store.dispatch("globals/setDSS", this.searchString);
        //this.filterList2();
      }, 1000);
    },
    resetSearch: function() {
      this.searchString = "";
      this.$store.dispatch("globals/setDSS", "");
      //this.filterList();
    }
  },
  watch: {
    "$store.state.n_user.n_users": function() {
      this.reportMonth = [];
      this.loadReportUsers();
    },
    "$store.state.territory.territories": function() {
      this.loadReportTerritories();
    },
    "$store.state.seminar.vendors": function() {
      this.loadReportVendors();
    },
    "$store.state.seminar.mailer_types": function() {
      this.loadReportMailers();
    },
    "$store.state.seminar.artwork_types": function() {
      this.loadReportArtworks();
    },
    reportTerritoryEdit: function() {
      this.$store.dispatch(
        "globals/setReportTerritory",
        this.reportTerritoryEdit
      );
    },
    reportVendorEdit: function() {
      this.$store.dispatch("globals/setReportVendor", this.reportVendorEdit);
    },
    reportMailerEdit: function() {
      this.$store.dispatch("globals/setReportMailer", this.reportMailerEdit);
    },
    reportArtworkEdit: function() {
      this.$store.dispatch("globals/setReportArtwork", this.reportArtworkEdit);
    }
  }
};
</script>

<style></style>
